'use client';

// npm packages
import React, { useEffect, useState, useRef } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useDispatch, useSelector } from 'react-redux';

// components
import { PHONE } from '@/constants';
import {
  setTimer,
  setCurrentPage,
  setIsOpenLoginSignup,
  setBackButton,
  reset,
} from '@/redux/reducers/auth-reducer';
import { cn } from '@/utils/cn';
import { clearSpinTheWheelDataForNewRound } from '@/redux/reducers/spin-the-wheel-reducer';
import Icon from '../Icon';
import LoginInput from './LoginInput';

// utils
import TopHeaderTitle from '../Header/TopHeaderTitle';
import OTP from './OTP';

function LoginSignup({
  onView,
  onClose = () => {},
  redirectTo = '',
  onSuccessLoginCallback = () => {},
  className = '',
}) {
  const dispatch = useDispatch();
  const router = useRouter();
  const pathname = usePathname();
  const modalRef = useRef(null);

  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [activeTab, setActiveTab] = useState(PHONE);

  const auth = useSelector((state) => state.auth);

  const { isOpenLoginSignup, timer, currentPage, isLoggedIn } = auth;
  const { isEnabledFakeSpinner } = useSelector((state) => state.spinTheWheel);

  // useEffect(() => {
  //   if (isLoggedIn && pathname === "/login") {
  //     const userConfirmed = confirm(
  //       "You are already logged in. Would you like to return to the homepage?"
  //     );
  //     if (userConfirmed) {
  //       router.back();
  //     }
  //   };
  // }, [])

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        dispatch(reset());
        dispatch(setIsOpenLoginSignup(true));
      }, 100);
    } else {
      dispatch(setIsOpenLoginSignup(false));
    }
  }, [onView]);

  useEffect(() => {
    const resendTimerInterval = setInterval(() => {
      if (timer > 0) dispatch(setTimer(timer - 1));
      else clearInterval(resendTimerInterval);
    }, 1000);

    return () => clearInterval(resendTimerInterval);
  }, [timer, setTimer]);

  const handleUserInput = (data) => {
    if (activeTab === PHONE) {
      setPhone(data);
    } else {
      setEmail(data);
    }
  };

  const handleClose = () => {
    setTimeout(() => {
      dispatch(setBackButton());

      // TODO: check if login button is closed or not
      if (isEnabledFakeSpinner) {
        dispatch(clearSpinTheWheelDataForNewRound());
      }

      onClose(false);
    }, 1);
  };

  const handleBackButton = () => {
    if (currentPage === 'otp') {
      dispatch(setCurrentPage('login'));
    } else if (currentPage === 'login') {
      dispatch(setCurrentPage('home'));
      // TODO: check if login button is closed or not
      if (isEnabledFakeSpinner) {
        dispatch(clearSpinTheWheelDataForNewRound());
      }

      router.back();
    }
  };

  const renderLoginTab = () => (
    <LoginInput
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      onUserInput={handleUserInput}
    />
  );

  const renderOtpTab = () => (
    <OTP
      activeTab={activeTab}
      userInfo={activeTab === PHONE ? phone : email}
      setActiveTab={setActiveTab}
    />
  );

  const handleRoute = () => {
    if ((pathname === '/login' || pathname === '/signup') && isLoggedIn) {
      // router.refresh();
      router.back();
      // router.push("/");
    } else if (redirectTo.length > 0) {
      router.push(redirectTo);
    } else if (pathname.includes('my-orders')) {
      router.push('/');
      // login successful
      // window.location.reload();
    }
  };

  const handleSuccessLogin = () => {
    dispatch(setCurrentPage('home'));
    onClose(false);

    handleRoute();
  };

  const renderTab = () => {
    switch (currentPage) {
      case 'login':
        return renderLoginTab();
      case 'otp':
        return renderOtpTab();
      case 'successLogin':
        return handleSuccessLogin();
      default:
        return null;
    }
  };

  if (!isOpenLoginSignup) {
    return null;
  }

  if (!onView) return null;
  return (
    <div
      className={cn(
        'w-full h-full bg-white lg:bg-black/30 fixed lg:inset-0 opacity-50 z-[199] lg:z-[700] invisible lg:flex justify-center items-center lg:overflow-y-auto transition-all duration-300',
        isOpenLoginSignup && '!opacity-100 !visible',
      )}
    >
      <div
        ref={modalRef}
        className={cn(
          'h-full lg:h-auto opacity-50 scale-90 invisible transition-all duration-100',
          isOpenLoginSignup && '!opacity-100 !scale-100 !visible',
        )}
      >
        <div className="bg-transparent w-full border-none lg:border lg:w-[480px] lg:rounded-xl relative">
          {/* For Mobile view only */}
          <TopHeaderTitle
            onBack={handleBackButton}
            title="Log In"
            iconName="angle-down"
          />

          <div className="flex flex-col">
            <Icon
              type="close"
              color="#fff"
              className="hidden lg:flex ml-auto flex-row items-center justify-end  mb-16 size-[24px] cursor-pointer"
              onClick={() => handleClose()}
            />
            {renderTab()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginSignup;
